import { ExperienceItem } from '../types';
import { useMemo } from 'react';
import { nearestColor } from '../helpers/nearest-color';
import matchingPalette from '../data/matching-palette.json';
import { clamp } from '@/utils/clamp';
import { useIsTouch } from '@/hooks/use-is-touch';

export function useColorsData(experienceItems: ExperienceItem[]) {
  const isTouch = useIsTouch();

  return useMemo(
    () =>
      experienceItems
        .map((project) =>
          project.caseItems.map((item) =>
            item.colors.map((color) => ({
              color: color.color,
              ratio: color.ratio,
            }))
          )
        )
        .flat(2)
        .map((item, index) => ({
          index,
          color: item.color,
          radius: isTouch
            ? clamp(item.ratio, 0.5, 0.85) * 2
            : clamp(item.ratio, 0.2, 0.85) * 2.5,
          // radius: Math.max(0.4, item.ratio), // Cap the minumum values to a certain
          x: Math.cos(index) * 2,
          y: Math.sin(index) * 2,
          z: Math.cos(index) * 2,
        }))
        .map((item) => {
          // Find where it should cluster from the predefined palette
          const match = nearestColor(item.color.hex, matchingPalette.colors);
          return {
            ...item,
            color: item.color.hex,
            cluster: match.paletteIndex,
            match,
          };
        }),
    [experienceItems, isTouch]
  );
}
